import { render, staticRenderFns } from "./AsideFooter.vue?vue&type=template&id=6ea88548&scoped=true&"
import script from "./AsideFooter.vue?vue&type=script&lang=js&"
export * from "./AsideFooter.vue?vue&type=script&lang=js&"
import style0 from "./AsideFooter.vue?vue&type=style&index=0&id=6ea88548&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea88548",
  null
  
)

export default component.exports